import { Swiper, Navigation, Pagination, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade]);

// this file control all sliders used by the get this look section, including the main slider, secondary, tertiary and quaternary
// the sliders are synchronized and the quaternary sliders are controlled by the spots on the after image

export default (node) => {
  const sectionId = node.dataset.sectionId;
  const sliderEl = node.querySelector('[data-slider]');
  const secondaySliderEl = node.querySelector('[data-slider-secondary]');
  const tertiarySliderEl = node.querySelector('[data-slider-tertiary]');
  const quaternarySliderEl = node.querySelectorAll('[data-slider-quaternary]');
  const quaternarySliderSpots = node.querySelectorAll('[data-button-spot]');
  const paginationEl = node.querySelector('[data-slider-pagination]');

  const quaternarySliderSwipers = [];

  const oneSlide = node.dataset.oneSlide === 'true';
  let mainSwiper = null;

  // this is used to move the quaternary slider only
  const moveToSlide = (e) => {
    const { toIndex, parentIndex } = e.detail;
    quaternarySliderSwipers[parentIndex - 1].slideTo(toIndex - 1);
  };

  const initSlider = () => {
    mainSwiper = new Swiper(sliderEl, {
      slidesPerView: oneSlide ? 1.6 : 'auto',
      spaceBetween: 12,
      autoHeight: false,
      loop: true,
      centeredSlides: oneSlide,
      pagination: {
        el: paginationEl,
        type: 'fraction',
      },
      navigation: {
        nextEl: '[data-slider-next]',
        prevEl: '[data-slider-prev]',
      },
    });

    const secondaySwiper = new Swiper(secondaySliderEl, {
      spaceBetween: 30,
      effect: 'fade',
      crossFade: true,
      autoHeight: true,
    });

    const tertiarySwiper = new Swiper(tertiarySliderEl, {
      spaceBetween: 30,
      effect: 'fade',
      crossFade: true,
    });

    mainSwiper.on('slideChange', function () {
      secondaySwiper.slideTo(mainSwiper.realIndex);
      tertiarySwiper.slideTo(mainSwiper.realIndex);
    });

    // we have multiple quaternary sliders, we need to init each one
    if (quaternarySliderEl) {
      quaternarySliderEl.forEach((quaternarySlider) => {
        const quaternarySliderSwiper = new Swiper(quaternarySlider, {
          spaceBetween: 0,
          autoHeight: true,
        });
        quaternarySliderSwipers.push(quaternarySliderSwiper);
      });
    }

    // for each quaternary slider, we need to add click to all spots inside the after image
    if (quaternarySliderEl) {
      if (quaternarySliderSpots) {
        quaternarySliderSpots.forEach((spot) => {
          spot.addEventListener('click', (button) => {
            const index = button.currentTarget.dataset.buttonSpotIndex;
            const parentIndex = button.currentTarget.dataset.buttonBlockIndex;
            // dispatch event to move slider
            if (index) {
              document.dispatchEvent(
                new CustomEvent('look-slider:move', {
                  detail: { toIndex: index, parentIndex },
                })
              );
            }
          });
        });
      }
    }
  };

  /**
   * Init
   */
  initSlider();

  document.addEventListener('look-slider:move', moveToSlide);
};
